export default __webpack_public_path__ + "static/media/98BC1AB7-7728-4046-A2F2-336B2C98EDA7_1_105_c.96e5fcfe.jpeg";